import { FC } from "react";
import {
  Box,
  Heading,
  Text,
  Image,
  Flex,
  Icon,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { GiCheckMark } from "react-icons/gi";
import { IoCloseSharp } from "react-icons/io5";

import LogoText from "../assets/images/logoText.png";
import IosBanner1 from "../assets/images/iosBanner1.png";
import IosBanner2 from "../assets/images/iosBanner2.png";
import IosBanner3 from "../assets/images/iosBanner3.png";
import IosBanner4 from "../assets/images/iosBanner4.png";
import IosBanner5 from "../assets/images/iosBanner5.png";
import IosBanner6 from "../assets/images/iosBanner6.png";
import IosBanner7 from "../assets/images/iosBanner7.png";

export const WhyAffiliate: FC = () => {
  const bannerImages = [
    IosBanner1,
    IosBanner2,
    IosBanner3,
    IosBanner4,
    IosBanner5,
    IosBanner6,
    IosBanner7,
  ];

  const features = [
    {
      feature: "Booking & Availability",
      bookd: undefined,
      acuity: undefined,
      fresha: undefined,
    },
    {
      feature: "All in-one booking management",
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: "Automated calendar updates",
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: "Customized Professional Profile",
      bookd: undefined,
      acuity: undefined,
      fresha: undefined,
    },
    {
      feature: "Personalized booking page",
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: '"On holiday" status',
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: "Client Communication & Management",
      bookd: undefined,
      acuity: undefined,
      fresha: undefined,
    },
    {
      feature: "In-app notifications & reminders",
      bookd: "yes",
      acuity: "no",
      fresha: "yes",
    },
    {
      feature: "Financial Management & Security",
      bookd: undefined,
      acuity: undefined,
      fresha: undefined,
    },
    {
      feature: "Secure Payments",
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: "Discount codes & promotion",
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: "Business & Team Management",
      bookd: undefined,
      acuity: undefined,
      fresha: undefined,
    },
    {
      feature: "Add team members",
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: "Caters to all stylist types",
      bookd: "yes",
      acuity: "yes",
      fresha: "no",
    },
    {
      feature: "Booking radius for mobile stylists",
      bookd: "yes",
      acuity: "no",
      fresha: "no",
    },
    {
      feature: "Business analytics & data",
      bookd: "yes",
      acuity: "yes",
      fresha: "yes",
    },
    {
      feature: "Unique Selling Points",
      bookd: undefined,
      acuity: undefined,
      fresha: undefined,
    },
    {
      feature: "In-app client messaging",
      bookd: "yes",
      acuity: "no",
      fresha: "no",
    },
    {
      feature: "Booking Marketplace",
      bookd: "yes",
      acuity: "no",
      fresha: "yes",
    },
    {
      feature: "Admin & dispute support",
      bookd: "yes",
      acuity: "no",
      fresha: "no",
    },
  ];

  return (
    <Box p={{ base: "16px", lg: "80px" }} maxW={"1400px"} mx="auto">
      <Image src={LogoText} justifySelf={"flex-end"} mb="36px" w={"130px"} />

      <Heading
        fontSize={{ base: "36px", lg: "50px" }}
        color={"#000"}
        fontFamily={"RedHatDisplay-Bold"}
        fontWeight={900}
        textTransform={"uppercase"}
      >
        Why Book-d?
      </Heading>

      <Box
        mt={{ base: "24px", lg: "40px" }}
        color={"#000"}
        fontSize={{ base: "16px", lg: "18px" }}
      >
        <Text>
          Looking for an all-in-one business management platform? You're in the
          right place.
        </Text>
        <Text>
          Book-d allows you to leave all the boring admin stuff and focus on
          delivering a 5* service to your clients
        </Text>
      </Box>

      <Flex
        mt="48px"
        w="auto"
        mx={{ base: "0px", lg: "-60px" }}
        justifyContent="space-between"
      >
        {bannerImages.map((image, index) => (
          <Image
            key={index}
            src={image}
            flex="1 0 auto"
            maxW={`${(100 / bannerImages.length).toFixed(4)}%`}
          />
        ))}
      </Flex>

      <Flex justifyContent={"center"} my={{ base: "40px", lg: "80px" }}>
        <Button
          bg={"#FF8E3C"}
          _hover={{ bg: "#FF8E3C" }}
          h="58px"
          px="60px"
          fontSize={{ base: "16px", lg: "20px" }}
          fontFamily={"RedHatDisplay-Bold"}
          borderRadius={"38px"}
          color={"white"}
          textTransform={"uppercase"}
          onClick={() =>
            window.open(
              "https://apps.apple.com/gb/app/book-d-beauty-booking-software/id6503949063",
              "_blank"
            )
          }
        >
          Sign up now
        </Button>
      </Flex>

      <Box mt={{ base: "50px", lg: "96px" }}>
        <Heading
          fontSize={{ base: "36px", lg: "50px" }}
          color={"#000"}
          fontFamily={"RedHatDisplay-Bold"}
          fontWeight={900}
          textTransform={"uppercase"}
          w={"75%"}
        >
          How does Book-d compare to other platforms?
        </Heading>

        <TableContainer
          mt="48px"
          w={{ base: "100%", lg: "768px" }}
          justifySelf={"center"}
          border={"1px solid #D9D9D9"}
          fontSize={{ base: "16px", lg: "18px" }}
          color={"#000"}
        >
          <Table variant="simple">
            <Thead bg="#EBEBEB">
              <Tr>
                <Th
                  textTransform={"capitalize"}
                  fontSize={{ base: "16px", lg: "18px" }}
                >
                  Features
                </Th>
                <Th
                  textTransform={"capitalize"}
                  fontSize={{ base: "16px", lg: "18px" }}
                >
                  Bookd
                </Th>
                <Th
                  textTransform={"capitalize"}
                  fontSize={{ base: "16px", lg: "18px" }}
                >
                  Acuity
                </Th>
                <Th
                  textTransform={"capitalize"}
                  fontSize={{ base: "16px", lg: "18px" }}
                >
                  Fresha
                </Th>
              </Tr>
            </Thead>

            <Tbody bg="#F9F6F1">
              {features.map((feature, index) => (
                <Tr key={index}>
                  <Td
                    whiteSpace={{ base: "normal", sm: "nowrap" }}
                    wordBreak={{ base: "break-word", sm: "normal" }}
                  >
                    {feature.feature}
                  </Td>
                  <Td>
                    {feature.bookd ? (
                      feature.bookd === "yes" ? (
                        <Icon boxSize={"28px"}>
                          <GiCheckMark />
                        </Icon>
                      ) : (
                        <Icon boxSize={"28px"}>
                          <IoCloseSharp />
                        </Icon>
                      )
                    ) : null}
                  </Td>
                  <Td>
                    {feature.acuity ? (
                      feature.acuity === "yes" ? (
                        <Icon boxSize={"28px"}>
                          <GiCheckMark />
                        </Icon>
                      ) : (
                        <Icon boxSize={"28px"}>
                          <IoCloseSharp />
                        </Icon>
                      )
                    ) : null}
                  </Td>
                  <Td>
                    {feature.fresha ? (
                      feature.fresha === "yes" ? (
                        <Icon boxSize={"28px"}>
                          <GiCheckMark />
                        </Icon>
                      ) : (
                        <Icon boxSize={"28px"}>
                          <IoCloseSharp />
                        </Icon>
                      )
                    ) : null}
                  </Td>
                </Tr>
              ))}

              <Tr>
                <Td>Affordability & fees</Td>
                <Td whiteSpace="normal" wordBreak="break-word">
                  Free tier available / £10 monthly for premium with no hidden
                  fees
                </Td>
                <Td whiteSpace="normal" wordBreak="break-word">
                  Starts at £20/month with tiered pricing and additional fees
                </Td>
                <Td whiteSpace="normal" wordBreak="break-word">
                  Free basic plan, but charges a 20% commission on new clients
                  from their marketplace + other fees
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};
